































import Vue, { PropOptions } from 'vue'
import images from '@assets/images/tracking/white'
import { GroupedActivityItem } from '@/types/user/API/ReqRes/userActivity'
type Level = 'better' | 'same' | 'worse' | 'less' | 'more' | 'skip'
export default Vue.extend({
  name: 'LogEntry',
  props: {
    type: String as PropOptions<'sleep'|'pain'|'activity'>,
    cardType: String as PropOptions<'sleep'|'pain'|'activity'>,
    data: Object as PropOptions<GroupedActivityItem>
  },
  computed: {
    isActive (): boolean {
      return this.type === this.cardType
    },
    level (): Level {
      const key = `${this.type}Level` as keyof GroupedActivityItem
      return this.data[key] as Level
    },
    isNotSkipped (): boolean {
      return this.level !== 'skip'
    }
  },
  data () {
    return {
      images,
      showImage: false
    }
  },
  watch: {
    level () {
      this.showImage = false
    }
  },
  methods: {
    imageLoaded () {
      this.showImage = true
    }
  }
})
